import { render, staticRenderFns } from "./ScoreRecord.vue?vue&type=template&id=7079fd26&scoped=true"
import script from "./ScoreRecord.vue?vue&type=script&lang=js"
export * from "./ScoreRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7079fd26",
  null
  
)

export default component.exports